// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
export const getValidateAddressMessage =
  (action: string, network?: string) => (address: string) => {
    if (network === undefined || address === '') {
      return `${action} address is not valid`;
    }
    if (network === '0') {
      const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/;
      if (!ethAddressRegex.test(address)) {
        return `${action} address is not valid`;
      }
    }
    return '';
  };
